/** Typed fetch client for the Go API. DTO types are hand-written against the Go handlers.
 *  Grows per milestone; storefront endpoints first. */
export class ApiError extends Error {
    status;
    constructor(status, message) {
        super(message);
        this.status = status;
        this.name = "ApiError";
    }
}
export function createApiClient(opts) {
    async function request(method, path, body) {
        const headers = { "Content-Type": "application/json" };
        const token = opts.getAccessToken?.();
        if (token)
            headers.Authorization = `Bearer ${token}`;
        const res = await fetch(opts.baseURL + path, {
            method,
            headers,
            body: body === undefined ? undefined : JSON.stringify(body),
        });
        if (!res.ok) {
            const payload = (await res.json().catch(() => null));
            throw new ApiError(res.status, payload?.message ?? res.statusText);
        }
        return res.json();
    }
    return {
        get: (path) => request("GET", path),
        post: (path, body) => request("POST", path, body),
        patch: (path, body) => request("PATCH", path, body),
        delete: (path, body) => request("DELETE", path, body),
        /** GET /healthz — placeholder first typed endpoint; storefront bootstrap lands in M2/F1. */
        healthz: () => request("GET", "/healthz"),
    };
}
/** Money is integer minor units everywhere; format at the edge only. */
export function formatMoney(amountCents, currency, locale = "en-US") {
    const exponent = ZERO_DECIMAL_CURRENCIES.has(currency) ? 0 : 2;
    return new Intl.NumberFormat(locale, { style: "currency", currency }).format(amountCents / 10 ** exponent);
}
const ZERO_DECIMAL_CURRENCIES = new Set(["JPY", "KRW", "VND", "CLP", "ISK", "UGX", "RWF", "GNF", "PYG", "XAF", "XOF", "XPF", "KMF", "DJF", "BIF", "VUV", "MGA"]);
//# sourceMappingURL=index.js.map